const ENForgotPassword = {
	"E-mail de recuperação de senha enviado" :"Password recovery email sent",
	"Email é obrigatório": "Email is required",
	"Esse link de recuperação de senha é invalido": "This password recovery link is invalid",
	"Recuperar senha": "Recover password",
	"Usuário não encontrado": "User not found",
	"Você está tentando alterar a senha de um usuário utilizando o email diferente do permitido para esse link": "You are trying to change a user's password using a different email address than the one allowed for this link"
};

export default ENForgotPassword;
